<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch" autocomplete="off">
    <el-form-item label="搜索范围">
    <!-- <el-date-picker
      v-model="dateRange"
      type="daterange"
      format="YYYY/MM/DD"
      value-format="YYYY/MM/DD"
      range-separator="-"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      :disabled-date="disabledDate"
      @change="handleDateChange"
    /> -->
    <el-date-picker
        v-model="dateStartRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="开始时间"
        :disabled-date="disabledDate"
        @change="handleDateStartChange"
      />
      <el-date-picker
        v-model="dateEndRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateEndChange"
      />
  </el-form-item>
    <el-form-item label="商品编号">
      <el-input v-model="queryParam.goodsnum" placeholder="输入商品编号" />
    </el-form-item>
    <el-form-item label="商品名称">
      <el-input v-model.trim="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <el-form-item label="客户名称">
      <el-input v-model.trim="queryParam.platname" placeholder="输入客户名称" />
    </el-form-item>
    <el-form-item label="客户商品名称">
      <el-input v-model.trim="queryParam.platgoodsname" placeholder="输入客户商品名称" />
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListGoodsTemp">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="primary"
          @click="doGetGoodsTempTrashList"
          v-hasPermission="['goods']"
          >回收站</el-button
        >

        <el-button
          type="danger"
          @click="(dialog = true), doGoodsTempAdd()"
          v-hasPermission="['goods:goodsTemp:add']"
          >新增过渡商品</el-button
        >
        <el-button
          type="danger"
          @click="openImport('goods:importTemp')"
          v-hasPermission="['goods:importTemp']"
          >导入过渡商品</el-button
        >
        <el-button
          type="danger"
          @click="openImport('goods:importTempEdit')"
          v-hasPermission="['goods:importTempEdit']"
          >批量导入过渡商品修改</el-button
        >
        <el-button
          type="danger"
          style=""
          :loading="loadingexport" @click="doExportGoodsTemp"
          v-hasPermission="['goods:goodsTemp:export']"
          >{{loadingexport ? "处理中 ..." : "导出过渡商品"}}<el-tooltip content="一次最多导出8万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button
        >
      </div>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionGoods"
        class="mainTable"
        row-key="tempid"
        height="600"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="商品编号" prop="goodsnum" width="230"/>
        <el-table-column label="商品名称" prop="name" width="200"/>
        <el-table-column label="商品规格" prop="specification" width="120" />
        <el-table-column label="客户名称" prop="platname" />
        <el-table-column label="客户商品名称" prop="platgoodsname"/>
        <el-table-column label="客户商品规格" prop="platspecification" />
        <el-table-column label="客户编号SKU" prop="platgoodsnum"/>
        <el-table-column label="操作" fixed="right" width="130">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doGoodsTempEdit(scope.$index, scope.row)"
              v-hasPermission="['goods:goodsTemp:edit']"
              >编辑</el-link
            >

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此商品吗？"
              width="200px"
              @confirm="doGoodsTempDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
            
            <el-popconfirm
              v-if="scope.row.status===1"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要此商品移到回收站吗？"
              width="200px"
              @confirm="doGoodsTempTrash(scope.$index, scope.row, 2)"
            >
              <template #reference>
                <el-link
                  v-hasPermission="['goods:goodsTemp:remove']"
                  size="small"
                  type="danger"
                  >移到回收站</el-link
                >
              </template>
            </el-popconfirm>

            <el-popconfirm
              v-if="scope.row.status===2"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要此商品恢复到过渡库吗？"
              width="200px"
              @confirm="doGoodsTempTrash(scope.$index, scope.row, 1)"
            >
              <template #reference>
                <el-link
                  v-hasPermission="['goods:goodsTemp:recover']"
                  size="small"
                  type="danger"
                  >恢复过渡库</el-link
                >
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <div>
          <el-button type="danger" v-if="queryParam.status===1" @click="showBatchGoodsTempRemoveRecoverDialog('goodsRemove')" v-hasPermission="['goods:goodsTemp:remove']">批量移动回收站</el-button>
          <el-button type="danger" v-if="queryParam.status===2" @click="showBatchGoodsTempRemoveRecoverDialog('goodsRecover')" v-hasPermission="['goods:goodsTemp:recover']">批量恢复过渡库</el-button>
      </div>
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="55%"
    @close="doGoodsTempClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="goodsFormRef"
        :model="goodsForm"
        :rules="rules"
        label-width="120px"
        autocomplete="off"
      >
      <el-form-item label="商品编号" prop="goodsnum">
          <el-input
            v-model.trim="goodsForm.goodsnum"
            placeholder="请输入商品编号"
          />
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input
            v-model.trim="goodsForm.name"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item label="商品规格" prop="specification">
          <el-input
            v-model.trim="goodsForm.specification"
            placeholder="请输入商品规格"
          />
        </el-form-item>
        <el-form-item label="客户名称" prop="platname">
          <el-input
            v-model.trim="goodsForm.platname"
            placeholder="请输入客户名称"
          />
        </el-form-item>
        <el-form-item label="客户商品名称" prop="platgoodsname">
          <el-input
            v-model.trim="goodsForm.platgoodsname"
            placeholder="请输入客户商品名称"
          />
        </el-form-item>
        <el-form-item label="客户商品规格" prop="platspecification">
          <el-input
            v-model.trim="goodsForm.platspecification"
            placeholder="请输入客户商品规格"
          />
        </el-form-item>
        <el-form-item label="客户编号SKU" prop="platgoodsnum">
          <el-input
            v-model.trim="goodsForm.platgoodsnum"
            placeholder="请输入客户编号SKU"
          />
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doGoodsTempClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doGoodsTempSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>

  <BatchGoodsTempRemoveRecover ref="RefBatchGoodsTempRemoveRecover" @click="getListGoodsTemp"/>
</template>
        
<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listGoodsTemp, saveGoodsTemp, getGoodsTempInfo, exportGoodsTemp, deleteGoodsTemp, updateGoodsTemp } from "@/api/goodstemp";
// import util from "@/util/tool.js";
import storage from  "@/util/storage";

import BatchGoodsTempRemoveRecover from "@/components/common/batchGoodsTempRemoveRecover";


// import store from "@/store";

const router = useRouter();
let openImport = (routeName)=>{
  router.push({
    name: routeName
  });
}

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const goodsFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

// let dateRange = ref([]);

let dateStartRange = ref();
let dateEndRange = ref();

let title = ref("新增过渡商品");

const multipleSelection = ref([]);
const doSelectionGoods = (val) => {
  multipleSelection.value = val;
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  goodsnum: "",
  platgoodsname: "",
  platname: "",
  status: 1,
  created: "",
  changed: ""
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: "",
    goodsnum: "",
    platgoodsname: "",
    platname: "",
    status: 1,
    created: "",
    changed: ""
  };
  defaultDate()
  getListGoodsTemp();
};

const goodsForm = ref({
  tempid: null,
  name: null,
  goodsnum: null,
  specification: null,
  platname: null,
  platgoodsname: null,
  platspecification: "",
  platgoodsnum: "",
});

const defaultDate = () => {
    // const today = new Date()
    
    // // 一年前的日期
    // const startDate = new Date(today)
    // startDate.setFullYear(startDate.getFullYear() - 1)
  
    // // 格式化 YYYY-MM-DD
    // const formatDate = (date) => date.toISOString().slice(0, 10)
  
    // // 默认赋值
    // dateRange.value = [
    //   formatDate(startDate),
    //   formatDate(today)
    // ]
    // queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
    // queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");

    dateStartRange.value = ''
    dateEndRange.value = ''
    queryParam.value.created = ""
    queryParam.value.changed = ""
  }
  // 2. 禁用逻辑：不能选未来，范围最大一年
  const disabledDate = (time) => {
    console.log(time)
    // const now = Date.now()
    // const oneYearMs = 365 * 24 * 60 * 60 * 1000
  
    // // 禁用未来日期
    // if (time.getTime() > now) return true
  
    // // 已选开始日期 → 结束日期只能选 开始 ~ 开始+1年
    // if (dateRange.value?.[0]) {
    //   const start = new Date(dateRange.value[0]).getTime()
    //   return time.getTime() < start || time.getTime() > start + oneYearMs
    // }
  
    // return false
  }
  
  // 3. 防止手动输入超过一年范围
  // const handleDateChange = () => {
  //   if (!dateRange.value) return
  
    // const start = new Date(dateRange.value[0]).getTime()
    // const end = new Date(dateRange.value[1]).getTime()
    // const oneYearMs = 365 * 24 * 60 * 60 * 1000
  
    // if (end - start > oneYearMs) {
    //   const maxEnd = new Date(start + oneYearMs)
    //   dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
    // }
  //   queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
  //   queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
  // }

  const handleDateStartChange = () => {
  if (!dateStartRange.value) return
  if (dateEndRange.value) {
    if (dateStartRange.value > dateEndRange.value) {
      dateStartRange.value = ""
      queryParam.value.created = ""
      ElMessage.error('开始时间须小于结束时间');
      return false
    }
  }
  queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
}

const handleDateEndChange = () => {
  if (!dateEndRange.value) return

  if (dateStartRange.value > dateEndRange.value) {
    dateStartRange.value = ""
    queryParam.value.created = ""
    ElMessage.error('开始时间须小于结束时间');
    return false
  }
  queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
}

//批量移到回收站
let dialogBatchGoodsTempRemoveRecoverVisible = ref(false);
const RefBatchGoodsTempRemoveRecover = ref();
const showBatchGoodsTempRemoveRecoverDialog = (flag) => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的过渡商品项');
    return false
  }
  RefBatchGoodsTempRemoveRecover.value.changeVisible(!dialogBatchGoodsTempRemoveRecoverVisible.value);

  let tempids = []

  multipleSelection.value.forEach((goods) => {
      tempids.push(goods.tempid.toString())
  });

  RefBatchGoodsTempRemoveRecover.value.goodsTempRemoveRecoverMethod({
    tempid: tempids,
    status: flag==='goodsRemove'?2:1,
    flag: flag
  });
};

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("goodsPath")
  if (query) {
    queryParam.value = query
  }
  defaultDate()
  getListGoodsTemp();
});


const doGoodsTempAdd = () => {
  title.value = "新增过渡商品";
  resetForm()
};

const doGoodsTempDelete = (index, obj) => {
  deleteGoodsTemp(obj).then((res) => {
    if (res.data.code === 1) {
      getListGoodsTemp();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}


//回收站列表
const doGetGoodsTempTrashList = () => {
  queryParam.value.status = 2
  getListGoodsTemp();
}

//回收站
const doGoodsTempTrash = (index, obj, status) => {
  updateGoodsTemp({status, tempid:obj.tempid.toString(), name: obj.name}).then((res) => {
    if (res.data.code === 1) {
      getListGoodsTemp();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

const doGoodsTempEdit = (index, obj) => {
  // console.log(index,obj)
  title.value = "编辑过渡商品";
  // goodsForm.value = obj;//直接赋值会出问题

  let tempid = obj.tempid.toString()

  getGoodsTempInfo({ tempid}).then((res) => {
    goodsForm.value = res.data.extend.goods;
    goodsForm.value.tempid = res.data.extend.goods.tempid.toString()
  });
};

const doGoodsTempClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  goodsFormRef.value.resetFields()
};

const resetForm = () => {
  goodsForm.value = {
    tempid: null,
    name: null,
    goodsnum: null,
    specification: null,
    platname: null,
    platgoodsname: null,
    platspecification: "",
    platgoodsnum: "",
  };
};

const doGoodsTempSave = () => {
  goodsFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }  
    saveGoodsTemp(goodsForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListGoodsTemp();
          doGoodsTempClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新用户状态
//   const doGoodsStatus = (index, obj) => {
//     let status = obj.status == 1 ? 2 : 1;
//     let data = { status, name: obj.name, goodsid: obj.goodsid.toString() };
//     tableData.value[index].status = status;
//     saveGoods(data);
//   };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListGoodsTemp();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListGoodsTemp();
};

//商品表API
const getListGoodsTemp = () => {
  storage.remove('goodsTempPath')
  
   if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }

  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  // query.brandname = query.brandid?query.brandid.join(','):''
  // query.supplierids = query.supplierids?query.supplierids.join(','):''
  // query.catalogid = query.catalogid?query.catalogid.join(','):''
  // delete query.brandid
  // console.log(query)

  listGoodsTemp(query).then((res) => {//queryParam.value
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

// const getGoodsInfos = (goodsid)=>{
//     getGoodsInfo({ goodsid}).then((res) => {
//         console.log(res)
//     });
// }

const doExportGoodsTemp = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  //queryParam.value.pageSize = 5000;
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  // query.brandname = query.brandid?query.brandid.join(','):''
  // query.supplierids = query.supplierids?query.supplierids.join(','):''
  // query.catalogid = query.catalogid?query.catalogid.join(','):''
  query.pageSize = 10000
  // delete query.brandid

  loadingexport.value = true;
  exportGoodsTemp(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};

//表单验证规则
const rules = ref({
  goodsnum: [
    {
      required: true,
      message: "请输入商品编号",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "商品编号长度2到200",
      trigger: "blur",
    },
  ],
  name:[
    {
      required: true,
      message: "请输入商品名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "商品名称长度2到200",
      trigger: "blur",
    },
  ],
  platname: [
    {
      required: true,
      message: "请输入客户名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "客户名称长度2到200",
      trigger: "blur",
    },
  ],
  platgoodsname: [
    {
      required: true,
      message: "请输入客户商品名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "客户商品名称长度2到200",
      trigger: "blur",
    },
  ],
  platgoodsnum: [
    {
      required: true,
      message: "请输入客户编号SKU",
      trigger: "blur",
    },
    {
      min: 2,
      max: 400,
      message: "客户编号SKU名称长度2到400",
      trigger: "blur",
    },
  ],
  // platspecification: [
  //   {
  //     required: true,
  //     message: "请填写客户商品规格",
  //     trigger: "blur",
  //   },
  //   {
  //     min: 2,
  //     max: 200,
  //     message: "商品规格长度2到200",
  //     trigger: "blur",
  //   },
  // ],
});
</script>